var parent = require('../../es/reflect/construct');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/reflect/construct.js
// module id = 460
// module chunks = 0 1